import { useEffect } from "react";

import { WipDetailsViewModel } from "../../viewmodels/wips/WipDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";

import { useParams } from "react-router-dom";
import SimpleNotification from "../../components/SimpleNotification";
import CreateWipForm from "../../components/forms/wips/CreateWipForm";
import EmbeddedAuditHistory from "../../components/audit/EmbeddedAuditHistory";
import { getAuditApiEntityType } from "../../components/audit/auditEntityConfig";

function WipDetails(props) {
  const { logout } = props;

  const { wipId } = useParams();

  const {
    emptyModal,
    setEmptyModelOpen,
    showSimpleNotification,
    setShowSimpleNotification,
    roomOptions,
    getRoomOptionsForDropdown,
    wip,
    onAddItemToWipByBarcode,
    getRemoveReasonsOptionsForDropdown,
    updateWip,
    getWipDetails,
    openSlideForManufacturedItemDetails,
    setSlideOver,
    slideOver,
    onAskReturnIncomingItem,
    onAskDeleteWipOutputItem,
    openAddPriceGroupModal,
    setOutgoingSelectedItems,
    outgoingSelectedItems,
    calculateCostForWipOutgoingItems,
    printWipDetailsReport,
    printWipSummaryReport,
    printWipDerivativesReport,
    showErrorModal,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    fetchRowDetails,
    fetchOutgoingRowDetails,
    outgoingLoadingRows,
    outgoingRowDetails,
    fetchOutgoingSubRowDetails,
    outgoingSubRowDetails,
    outgoingSubLoadingRows,
    setOutgoingRowDetails,
    setOutgoingSubRowDetails,
    onWipItemTotalCostEditComplete,
  } = WipDetailsViewModel(logout, wipId);

  const getInfoForWip = async function () {
    const result1 = await getRoomOptionsForDropdown();
    const result2 = await getRemoveReasonsOptionsForDropdown();

    getWipDetails();
  };

  useEffect(() => {
    getInfoForWip();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <CreateWipForm
          isEdit={true}
          wip={wip}
          roomOptions={roomOptions}
          onAddItemToWipByBarcode={onAddItemToWipByBarcode}
          updateWip={updateWip}
          openSlideForManufacturedItemDetails={
            openSlideForManufacturedItemDetails
          }
          onAskReturnIncomingItem={onAskReturnIncomingItem}
          onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
          openAddPriceGroupModal={openAddPriceGroupModal}
          setOutgoingSelectedItems={setOutgoingSelectedItems}
          outgoingSelectedItems={outgoingSelectedItems}
          calculateCostForWipOutgoingItems={calculateCostForWipOutgoingItems}
          printWipDetailsReport={printWipDetailsReport}
          printWipSummaryReport={printWipSummaryReport}
          showErrorModal={showErrorModal}
          printWipDerivativesReport={printWipDerivativesReport}
          loadingRows={loadingRows}
          rowDetails={rowDetails}
          fetchSubRowDetails={fetchSubRowDetails}
          subRowDetails={subRowDetails}
          subLoadingRows={subLoadingRows}
          fetchRowDetails={fetchRowDetails}
          onWipItemTotalCostEditComplete={onWipItemTotalCostEditComplete}
          setEmptyModelOpen={setEmptyModelOpen}
          outgoing={{
            fetchOutgoingRowDetails: fetchOutgoingRowDetails,
            outgoingLoadingRows: outgoingLoadingRows,
            outgoingRowDetails: outgoingRowDetails,
            fetchOutgoingSubRowDetails: fetchOutgoingSubRowDetails,
            outgoingSubRowDetails: outgoingSubRowDetails,
            outgoingSubLoadingRows: outgoingSubLoadingRows,
            setOutgoingRowDetails: setOutgoingRowDetails,
            setOutgoingSubRowDetails: setOutgoingSubRowDetails,
          }}
        />
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
        customClass="max-w-3xl"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WipDetails),
);
